import { PrimaryButton, Icon } from "@fluentui/react";
import React, { useContext } from "react";
import { ColumnOptionsContext } from "./ColumnOptions";

export const ApplyButton = () => {
  const { onClickApply, strings } = useContext(ColumnOptionsContext);

  return (
    <PrimaryButton
      iconProps={{ iconName: "Sync" }}
      onClick={onClickApply}
    >
      {strings.applyButtonLabel}
    </PrimaryButton>
  );
};
